// extracted by mini-css-extract-plugin
export default {"p_tye":"ea2a3c7579","slcted":"_37f4b2ac89","slc_color":"_23632bffbd","item_p":"f940c42d31","r0":"_36750c65e5"};